
import * as THREE from 'three';
import { Pane } from 'tweakpane';
import Ring from "./ring"


export default class Scene {
    scene = new THREE.Scene();
    camera = new THREE.PerspectiveCamera( 60, 1, 0.1, 60 );
    renderer = new THREE.WebGLRenderer({
        antialias: true,
        alpha: true
    });
    intersectable = false;
    pointer = new THREE.Vector2();
    components = {};
    activeIndex = -1;
    PARAMS = {
        x: 0,
        y: 0,
        z: 0,
        a: 1,
        hovered: 0
    }
    constructor({ el }) {
        this.$graphics = el

        this.renderer.setClearAlpha( this.PARAMS.a );

        this.initialize();
        this.setComponents();

        this.handleResize();
        this.boundResize = this.handleResize.bind(this);
        ScrollTrigger.addEventListener("refresh", this.boundResize)
        window.addEventListener("resize", this.boundResize);
    }
    
    play() {
        this.isPaused = false;
        this.renderer.setAnimationLoop(this.hanedleRender.bind(this));
        this.components.ring.enter()
    }

    pause() {
        this.isPaused = true;
        this.renderer.setAnimationLoop(null);
    }

    focus() {
        const timeline = new gsap.timeline({
            onComplete: () => {
                this.pause()
            }
        })
        timeline.add(this.components.ring.leave(this.activeIndex), "a")

        return timeline
    }

    highlight(index) {
        const planes = this.components.ring.planes;
        
        this.activeIndex = index;
        const activePlane = planes[this.activeIndex];
        const inactivePlanes = planes.filter(p => p !== activePlane);

        if (activePlane) {
            gsap.to(this.PARAMS, { hovered: 1, duration: .5, onUpdate: () => {
                activePlane.material.uniforms.uAlpha.value =  this.PARAMS.hovered  * 0.7 + 0.3
                inactivePlanes.forEach(plane => {
                    plane.material.uniforms.uAlpha.value = 1 - this.PARAMS.hovered * 0.7
                })
            }})
        } else {
            this.activeIndex = -1
            gsap.to(this.PARAMS, { hovered: 0, duration: .5, onUpdate: () => {
                planes.forEach(plane => {
                    plane.material.uniforms.uAlpha.value = (1. - this.PARAMS.hovered) * 0.7 + 0.3
                })
            }})
        }
    }

    setComponents() {
        const { scene, renderer, camera } = this;

        this.components.ring = new Ring({ scene, renderer, camera })
        this.components.ring.initialize()
    }

    initialize() {
        const { $graphics } = this;
        $graphics.appendChild( this.renderer.domElement );

        this.camera.position.z = 0;
    }


    hanedleRender() {        
        this.camera.updateMatrixWorld();
        Object.keys(this.components).forEach(_ => {
            if ("handleRender" in this.components[_]) this.components[_].handleRender(this.pane);
        });


		this.renderer.render(this.scene, this.camera);
    }

    handleResize() {
        const width = this.$graphics.offsetWidth
        const height = this.$graphics.offsetHeight;
        this.camera.aspect = width / height;
        this.camera.updateProjectionMatrix();

        this.renderer.setSize( width, height );

        Object.keys(this.components).forEach(_ => {
            if ("handleResize" in this.components[_]) this.components[_].handleResize(width, height);
        });
    }

    setDebug() {
        this.pane = new Pane();
        Object.keys(this.components).forEach(_ => {
            if ("setDebug" in this.components[_]) this.components[_].setDebug(this.pane);
        });
    }

    dispose() {
        Object.keys(this.components).forEach(_ => {
            this.components[_].dispose();
            delete this.components[_];
        });

        ScrollTrigger.removeEventListener("refresh", this.boundResize)
        window.removeEventListener("resize", this.boundResize);
        this.renderer.dispose();
    }
}
